import views from '@/views/';

export default [
  {
    component: views.statistics.Finance,
    label: '财务统计',
    path: 'finance',
    name: 'Finance',
  },
  {
    component: views.statistics.Order,
    label: '订单统计',
    path: 'order',
    name: 'Order',
  },
  {
    component: views.statistics.Drug,
    label: '药品统计',
    path: 'drug',
    name: 'Drug',
  },
  {
    component: views.feeDispense.feeDetail,
    label: '已收费详情',
    path: 'feedetail',
    name: 'feeDetail',
    menuHidden: true,
  },
  // {
  //   component: views.statistics.drugStatistics,
  //   label: '药品统计',
  //   path: 'drugStatistics',
  //   name: 'drugStatistics',
  // },
];
